import { BaseMutations } from '@/store/base-mutations';
import { Notifications, NotificationsFilters } from '../types';
import NotificationsState from './state';
import { popup_notifications_limit } from '../consts';

export default class NotificationsMutations extends BaseMutations<NotificationsState> {
  SET_NOTIFICATIONS(notifs: Notifications.Notification[]) {
    this.state.notifs = notifs;
  }

  SET_SECTIONS_NOTIFICATIONS_FILTER(sections: Notifications.Section[]) {
    this.state.sections = sections;
  }

  SET_LAST_NOTIFICATIONS(last_notifs: Notifications.Notification[]) {
    this.state.last_notifs = last_notifs;
  }

  SET_LAST_NOTIFICATIONS_IS_WITHOUT_NEWS(notifs: Notifications.Notification[]) {
    this.state.last_notifs_is_without_news = notifs;
  }

  SET_LAST_NEWS(last_news: Notifications.Notification[]) {
    this.state.last_news = last_news;
  }

  SET_NUMBER_UNREAD_NOTIFICATION(number_unread_notifications: number) {
    this.state.number_unread_notifications = number_unread_notifications;
  }

  SET_USER_NOTIFS(user_notifs: Notifications.UserNotifications[]) {
    this.state.user_notifs = user_notifs;
  }

  TOGGLE_LOADING_NOTIFS(toggle: boolean) {
    this.state.notifs_loading = toggle;
  }

  TOGGLE_UNREAD_FILTER(toggle: boolean) {
    this.state.filters.not_read_only = toggle;
  }

  SET_READ_NOTIFICATIONS(ids: Array<number>) {
    this.state.notifs.map((item) => {
      if (ids.includes(item.id)) {
        // eslint-disable-next-line no-param-reassign
        item.is_read = true;
      }
      return item;
    });
    this.state.last_notifs.map((item) => {
      if (ids.includes(item.id)) {
        // eslint-disable-next-line no-param-reassign
        item.is_read = true;
      }
      return item;
    });
    this.state.last_notifs_is_without_news.map((item) => {
      if (ids.includes(item.id !== null && item.id !== undefined ? item.id : NaN)) {
        // eslint-disable-next-line no-param-reassign
        item.is_read = true;
      }
      return item;
    });
    this.state.last_news.map((item) => {
      if (ids.includes(item.id)) {
        // eslint-disable-next-line no-param-reassign
        item.is_read = true;
      }
      return item;
    });

    // this.state.number_unread_notifications = this.state.notifs.filter((item) => item.is_read === false).length;
  }

  SET_CURRENT_PAGE_FOR_RETURN(value: number) {
    this.state.page_for_return = value;
  }

  SET_NOTIFICATION(item: Notifications.Notification) {
    this.state.notifs.unshift(item);
    this.state.notifs.pop();
    this.state.last_notifs.unshift(item);
    this.state.last_notifs.pop();

    if (item.section.slug === 'news_published') {
      this.state.last_news.unshift(item);
      this.state.last_news.pop();
    } else {
      this.state.last_notifs_is_without_news.unshift(item);
      this.state.last_notifs_is_without_news.pop();
    }

    if (item.is_popup_required) {
      this.state.popup_notifs.unshift(item);

      if (this.state.popup_notifs.length > popup_notifications_limit) {
        this.state.popup_notifs.pop();
      }
    }

    this.state.number_unread_notifications += 1;
  }

  SET_NOTIFICATION_NEWS(item: Notifications.Notification) {
    this.state.last_news.unshift(item);
    this.state.last_news.pop();
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof NotificationsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_USER_SETTINGS_NOTIFICATIONS(id: number) {
    const item = this.state.user_notifs.find((item) => item.id === id);

    if (item) {
      item.is_allowed = !item.is_allowed;
    }
  }

  SET_UNREAD_ENTITIES(items: Notifications.UserUnreadEntities[]) {
    this.state.unread_entities = items;
  }

  UPD_UNREAD_ENTITIES(page_id: number) {
    const item = this.state.unread_entities.find((item) => item.page_id === page_id);

    if (item) {
      item.is_allowed = !item.is_allowed;
    }
  }

  SET_POPUP_NOTIFICATIONS(notifs: Notifications.Notification[]) {
    this.state.popup_notifs = notifs;
  }
}
